import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBond = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3377 3.29848C15.1497 3.10753 14.8929 3 14.625 3H6.75C6.01553 3 5.31438 3.29655 4.79991 3.81918C4.28597 4.34128 4 5.0461 4 5.77778V18.2222C4 18.9539 4.28597 19.6587 4.79991 20.1808C5.31438 20.7035 6.01553 21 6.75 21H17.25C17.9845 21 18.6856 20.7035 19.2001 20.1808C19.714 19.6587 20 18.9539 20 18.2222V8.44444C20 8.18196 19.8968 7.92999 19.7127 7.74293L15.3377 3.29848Z",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 3V7C14 7.55228 14.4477 8 15 8H19",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 12H9",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 16H9",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBond;
